<div class="venue-map" [class.dark]="dark" [class.editing]="editing">
  <ng-container *ngIf="imageData; else noImage">
    <div class="venue-map-box" #imageBox
      [style.width.px]="boxSize?.width"
      [style.height.px]="boxSize?.height"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp($event)"
      (pointercancel)="onPointerUp($event)">
      <img class="venue-map-image" [src]="imageData" alt="Venue floor plan" draggable="false"
        (load)="onImageLoad($event)" />

      <div class="venue-map-marker"
        *ngFor="let view of markerViews; let i = index; trackBy: trackByMarker"
        [style.left.%]="view.marker.x"
        [style.top.%]="view.marker.y"
        (pointerdown)="onMarkerPointerDown($event, i)">
        <div class="venue-map-marker-name">{{ view.marker.entranceName }}</div>
        <div class="venue-map-marker-metrics">
          <span class="venue-map-metric">
            <span class="venue-map-metric-value">{{ view.entries }}</span>
            <span class="venue-map-metric-label">In</span>
          </span>
          <span class="venue-map-metric">
            <span class="venue-map-metric-value">{{ view.exits }}</span>
            <span class="venue-map-metric-label">Out</span>
          </span>
          <span class="venue-map-metric">
            <span class="venue-map-metric-value">{{ view.reentries }}</span>
            <span class="venue-map-metric-label">Re</span>
          </span>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #noImage>
    <div class="venue-map-empty">
      {{ editing ? 'Open settings (⚙) to upload a floor-plan image.' : 'No floor plan uploaded yet.' }}
    </div>
  </ng-template>
</div>
